import styled from '@emotion/styled';
import { tokens, Text, Link, Badge } from '@hotjar/hotsauce';
import {
  FilterKindEnum,
  UpsellFooterEnum,
} from '../../../domains/global-filters/model/FilterChain';
import type { UpsellType } from '../../../domains/global-filters/model/FilterChain';

const Container = styled.div`
  background-color: ${tokens.color.neutral_100};
  padding: ${tokens.spacer.x2};
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
`;

const StyledBadge = styled(Badge)`
  margin-right: ${tokens.spacer.x1};
`;

const StyledLink = styled(Link)`
  ${tokens.text('caption')};
`;

interface AddFilterFooterProps {
  showUpsellFooter?: UpsellFooterEnum;
  onUpsellClicked?: (upsellType: UpsellType) => void;
}

export const AddFilterFooter = ({
  showUpsellFooter,
  onUpsellClicked,
}: AddFilterFooterProps): JSX.Element | null => {
  switch (showUpsellFooter) {
    case UpsellFooterEnum.UnlockPlusFilter:
      return (
        <Container onClick={() => onUpsellClicked?.('footer')}>
          <div>
            <StyledBadge kind="custom" size="s" color={tokens.BRAND_COLORS.midnight_600}>
              upgrade
            </StyledBadge>
            <Text textType="caption">Uncover new insights with advanced filters</Text>
          </div>
          <StyledLink kind="standalone" as="button">
            See what&apos;s included
          </StyledLink>
        </Container>
      );
    case UpsellFooterEnum.UnlockBusinessFilter:
      return (
        <Container onClick={() => onUpsellClicked?.('footer')}>
          <div>
            <StyledBadge kind="custom" size="s" color={tokens.BRAND_COLORS.midnight_600}>
              upgrade
            </StyledBadge>
            <Text textType="caption">Uncover new insights with advanced filters</Text>
          </div>
          <StyledLink kind="standalone" as="button">
            See what&apos;s included
          </StyledLink>
        </Container>
      );
    case UpsellFooterEnum.UnlockScaleFilter:
      return (
        <Container onClick={() => onUpsellClicked?.(FilterKindEnum.Error)}>
          <div>
            <StyledBadge kind="custom" size="s" color={tokens.BRAND_COLORS.midnight_600}>
              upgrade
            </StyledBadge>
            <Text textType="caption">Uncover new insights with all filters</Text>
          </div>
          <StyledLink kind="standalone" as="button">
            See what&apos;s included
          </StyledLink>
        </Container>
      );
    default:
      return null;
  }
};
